import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface RemoveTenantParams {
  userId: string;
  tenantId: string;
}

export const useRemoveTenantMutation = () => {
  return useMutation({
    mutationFn: async ({ userId, tenantId }: RemoveTenantParams) => {
      await fetchClient.DELETE(
        '/administration/users/{userId}/tenants/{tenantId}',
        {
          params: {
            path: {
              userId,
              tenantId,
            },
          },
        },
      );
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
